const PREFIX = '[MSAL debug]';

function summarizeHash(hash: string): string {
  if (!hash) {
    return '(empty)';
  }

  const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const keys = [...params.keys()];
  return `len=${hash.length} keys=[${keys.join(', ')}] hasCode=${params.has('code')} hasError=${params.has('error')} error=${params.get('error') || ''}`;
}

function listMsalSessionKeys(): string[] {
  const keys: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && (key.startsWith('msal.') || key.includes('microsoft') || key.includes('pending'))) {
      keys.push(key);
    }
  }
  return keys.sort();
}

export function msalDebug(message: string, data?: Record<string, unknown>): void {
  if (data) {
    console.log(PREFIX, message, data);
  } else {
    console.log(PREFIX, message);
  }
}

export function msalDebugWarn(message: string, data?: Record<string, unknown>): void {
  if (data) {
    console.warn(PREFIX, message, data);
  } else {
    console.warn(PREFIX, message);
  }
}

export function msalDebugError(message: string, error?: unknown, data?: Record<string, unknown>): void {
  console.error(PREFIX, message, {
    ...data,
    error,
    errorMessage: error instanceof Error ? error.message : String(error ?? ''),
  });
}

export function msalDebugPageSnapshot(label: string): void {
  msalDebug(label, {
    href: window.location.href,
    pathname: window.location.pathname,
    search: window.location.search || '(empty)',
    hash: summarizeHash(window.location.hash),
    msalSessionKeys: listMsalSessionKeys(),
    pendingMicrosoftIdToken: !!sessionStorage.getItem('pendingMicrosoftIdToken'),
    returnPath: sessionStorage.getItem('returnPath'),
    microsoftAuthError: sessionStorage.getItem('microsoftAuthError'),
    authProvider: localStorage.getItem('authProvider'),
    hasAuthToken: !!localStorage.getItem('authToken'),
  });
}
